import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { UserService } from '../core/services/v2/user.service';
import { HealthsystemdialogComponent } from './healthsystemdialog/healthsystemdialog.component';

@Component({
  selector: 'app-health-categories',
  templateUrl: './health-categories.component.html',
  styleUrls: ['./health-categories.component.scss']
})
export class HealthCategoriesComponent implements OnInit {
  isLoggedIn: boolean = false;
  constructor(private userService: UserService, public dialog: MatDialog) {
    this.userService.getUserDetails().subscribe(
      (_) => {
        this.isLoggedIn = true;
      },
      (error) => {
        console.error(error);
        this.isLoggedIn = false;
      }
    );
  }

  ngOnInit() {
  }


  alert() {
    alert('Coming Soon');
  }

  openForm() {
    //  alert('test');

    const dialogRef = this.dialog.open(HealthsystemdialogComponent, {
      minWidth: '400px'
    });

    dialogRef.afterClosed().subscribe(
      (_) => { },
      (error) => { console.error(error); }
    );
  }
}
